export default "__VITE_ASSET__CVvH$AyP__"